<!-- <div id="add-vehicle" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Ajouter un nouveau <br> véhicule
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Immatriculation du véhicule</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="vehicle.name" (ngModelChange)="validator()" placeholder="FJ-203-DS"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="validated === false" (click)="submit()" class="button bold uk-margin-small-left" type="button">
                    Ajouter
                </button>
            </p>
        </div>
    </div>
</div> -->

<div id="add-vehicle" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase">
                    Ajouter un nouveau <br> véhicule
                </h2>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Immatriculation du véhicule</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="vehicle.name" (ngModelChange)="validator()" placeholder="FJ-203-DS"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Marque</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="vehicle.brand" placeholder="Volkswagen"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Modèle</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="vehicle.model" placeholder="Polo"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked">
                    <label class="label">Carburant</label>
                    <div class="uk-form-controls gridFuel">
                        <select class="uk-width-7-12 combo-list alt color-cold-grey bold uk-width-1-1 uk-align-left labelFuel" [(ngModel)]="vehicle.vehicleFuel">
                            <option value=0>Electrique</option>
                            <option value=1>Gazole</option>
                            <option value=2>SP-95</option>
                            <option value=3>SP-98</option>
                        </select>
                    </div>
                </div>
                
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Catégorie</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <!-- <input [(ngModel)]="vehicle.vehicleCategeory"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text"> -->
                            <select class="combo-list alt color-cold-grey bold uk-width-1-1 uk-align-left labelFuel" [(ngModel)]="vehicle.vehicleCategeory">
                                <option value="A">Citadine (A)</option>
                                <option value="B">Routiere (B)</option>
                                <option value="C">Familiale (C)</option>
                                <option value="D">Utilitaire (D)</option>
                                <option value="E">Autre (E)</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked">
                    <div class="uk-margin">
                        <label class="label">Description</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <input [(ngModel)]="vehicle.vehicleDetails"
                            class="input alt color-cold-grey bold uk-width-1-1" type="text">
                        </div>
                    </div>
                </div>
                <div class="uk-form-stacked" *ngIf="session.role.ability === 'super-admin'">
                    <div class="uk-margin">
                        <label class="label">Adhérant</label>
                        <div class="uk-form-controls uk-margin-small-top">
                            <select class="combo-list alt color-cold-grey bold uk-width-1-1"
                                [(ngModel)]="selectedSocietyId" (ngModelChange)="validator()">
                                <option [value]="0" disabled>Sélectionner un adhérant</option>
                                <option *ngFor="let s of societies" [value]="s.Id">
                                    {{ s.Name }} ({{ s.Code }})
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button [disabled]="validated === false" (click)="submit()" class="button bold uk-margin-small-left" type="button">
                    Ajouter
                </button>
            </p>
        </div>
    </div>
</div>